export default class DesactivarCategoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idCategoria) {
    try {
      const result = await this.#repository.desactivarCategoria(idCategoria)
      return result
    } catch (error) {
      throw error
    }
  }
}
